<template>
    <div>
        <v-card>
            <v-row class="ml-1 mr-1 mb-7">
                <v-col cols="11">
                    <v-card-title class="titulopagina">DESPACHOS DE ACEITE (MUESTREO LABORATORIO)</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                </v-col>
            </v-row>
		    <modal-ayuda></modal-ayuda>
        </v-card>
        <v-row class="ml-1 mr-1">
            <v-col cols="8">
                <v-row class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                    Despacho Guardado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-col class="col-md-12 col-sm-12">
                    <date-picker class="float-right" v-model="fechas" @change="cargarDespachos"
                        range-separator="|" range placeholder ="Búsqueda por Fechas" 
                        format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD">
                    </date-picker>
                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                </v-col>
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1">
            <v-col class="col-md-3 col-sm-12">
                <v-card>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Fecha:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <date-picker 
                                v-model="despacho.fecha" 
                                placeholder ="Seleccione Fecha" 
                                format="DD-MM-YYYY" 
                                :default-value="despacho.fecha" 
                                valueType="YYYY-MM-DD"
                                @change="cargarDespacho"
                            ></date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Guia:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-text-field v-model="despacho.guia" label="N° Guia" placeholder="N° Guia"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Humedad:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-text-field v-model="despacho.humedad" label="% Humedad" placeholder="Humedad %" @change="revisar_comas('humedad')"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            TK:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-select
                                :items="estanques"
                                item-text="codigo"
                                item-value="id"
                                v-model="despacho.estanque_aceites_id"
                                label="Estanque"
                                dense>

                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Acidez:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-text-field v-model="despacho.acidez" @change="revisar_comas('acidez')" label="% Acidez" placeholder="Acidez %"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="text-center">
                            <v-btn class="green darken-1" @click="generarDespacho">Grabar</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col>
                <v-data-table :headers="encabezado" :items="despachos" class="elevation-1">
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-6" @click="despacho = item">edit</v-icon>
                        <v-btn color="red darken-4" dark small icon @click="eliminar(item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        id: 0,
        alert: false,
        despachos: [],
        estanques: [],
        fechas:null,
        despacho: {
            fecha: '',
            guia: '',
            // sello: '',
            humedad:'',
            estanque_aceites_id: '3',
            acidez: '',
        },
        encabezado: [
            { text: 'Fecha', value: 'fecha', class:"cabecera" },
            { text: 'Guia', value: 'guia', class:"cabecera" },
            // { text: 'Sello', value: 'sello', class:"cabecera" },
            { text: 'Humedad (%)', value: 'humedad', class:"cabecera" },
            { text: 'Estanque', value: 'estanque', class:"cabecera" },
            { text: 'Acidez (%)', value: 'acidez', class:"cabecera" },
            { text: 'Opciones', value: 'actions', sortable: false, class:"cabecera"},
        ],
    }),
    mounted(){
        this.despacho.fecha = this.moment().format('YYYY-MM-DD');
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarDespacho();
        this.cargarEstanques();
    },
    methods:{
        validateNumber() {
            if (/^\d{9}$/.test(this.despacho.humedad)) {
            this.despacho.humedad = this.despacho.humedad.replace(/(\d{3})(\d{3})(\d{3})/, "$1.$2.$3");
            this.valid = true;
            } else if (/^(\d{3}\.){2}\d{3}$/.test(this.despacho.humedad)) {
            this.valid = true;
            } else {
            this.valid = false;
            }
        },
        editarDespacho(){
            
        },
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Despachos de Aceite (Laboratorio)`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se registra información de los despachos de aceite: Fecha del despacho, Número de Guía, Sellos, Estanque de origen y el % de Acidez.`},
                        {   tipo:`label`,   texto:`- En la tabla del lado derecho se pueden realizar busquedas por fecha o se puede modificar un registro.`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log(this.inputs);
                this.estanques = response.data.data;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar estanques ");
            });
        },
        async cargarDespacho(){
            this.mostrarLoading({titulo:`Buscando Despachos  ${this.despacho.fecha} ...`, color:'green'});
            let url = `${this.base_url}despacho_aceite/por_fecha/${this.despacho.fecha}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.despachos = res.data.data;
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e);
            });
        },
        async cargarDespachos(){
            this.mostrarLoading({titulo:`Buscando Despachos entre ${this.fechas[0]} y ${this.fechas[1]} ...`, color:'green'});
            let url = `${this.base_url}despacho_aceite/por_fecha/${this.fechas[0]}/${this.fechas[1]}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.despachos = res.data.data;
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar despachos ");
            });
        },

        async generarDespacho(){
            //this.mostrarLoading('Generando Despacho...')
            this.mostrarLoading({titulo:'Generando Despacho...',color:'green'})

            let body = {
                fecha: this.despacho.fecha,
                guia: this.despacho.guia,
                // sello: this.despacho.sello,
                humedad: this.despacho.humedad,
                acidez: this.despacho.acidez,
                estanque_aceites_id: this.despacho.estanque_aceites_id
            }
            let url = `${this.base_url}despacho_aceites`;
            if(this.despacho.id > 0){
                url = url + `/${this.despacho.id}`;
                await this.axios.put(url, body, this.headers).then((res)=>{
                    console.log('despacho actualizado', res.data.data);
                    this.alert = true;
                    this.ocultarLoading();
                    this.despacho = {fecha: res.data.data.fecha}
                    this.cargarDespacho();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al actualizar despacho ");
                });
            }else{
                await this.axios.post(url, body, this.headers).then((res)=>{
                    console.log('despacho creado', res.data.data);
                    this.alert = true;
                    this.ocultarLoading();
                    this.despacho = {fecha: res.data.data.fecha}
                    this.cargarDespacho();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al grabar despacho ");
                });
            }
            
        },
        async eliminar(item){
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: 'Desea eliminar despacho de aceite ?',
                okButton: 'Eliminar !!',
            })
            if(okei) {
                let body = { _method:"DELETE"}
                await this.axios.post(`${this.base_url}despacho_aceites/${item.id}`,body,this.headers).then((res)=>{
                    this.despacho = {fecha: this.moment().format('YYYY-MM-DD')}
                    this.cargarDespacho();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al grabar despacho ");
                });
            }
        },
        revisar_comas(type){
            let valor = this.despacho[type].replace(/,/g, '.');
            valor = Number(valor);

            if (type === 'humedad') {
                valor = valor.toFixed(2);
            }

            this.despacho[type] = valor;
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        ...mapState(['base_url', 'headers'])
    },
    components:{
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda':ModalAyudas
    },

}
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }
</style>